var React = require('react');

function ApiDocument (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"26.5","cy":"26.5","r":"26.5","fill":"#001B66","key":0}),React.createElement("ellipse",{"cx":"20.5536","cy":"20.5348","rx":"7.87778","ry":"7.86098","fill":"#55DF20","key":1}),React.createElement("path",{"d":"M29.3832 17.2827L18.4375 22.7575L29.3832 28.2322L40.3288 22.7575L29.3832 17.2827Z","stroke":"white","strokeWidth":"1.24435","strokeLinecap":"square","key":2}),React.createElement("path",{"d":"M18.4375 33.707L29.3832 39.1818L40.3288 33.707","stroke":"white","strokeWidth":"1.24435","strokeLinecap":"square","key":3}),React.createElement("path",{"d":"M18.4375 28.2324L29.3832 33.7072L40.3288 28.2324","stroke":"white","strokeWidth":"1.24435","strokeLinecap":"square","key":4})]);
}

ApiDocument.defaultProps = {"width":"53","height":"53","viewBox":"0 0 53 53","fill":"none"};

module.exports = ApiDocument;

ApiDocument.default = ApiDocument;
